import AccessibilityNewOutlinedIcon from '@mui/icons-material/AccessibilityNewOutlined';

/**
 * Percepção da imagem corporal: escala de silhuetas de Stunkard (Figure Rating
 * Scale, 1983), 9 figuras da mais magra à de maior volume corporal. O paciente
 * aponta a silhueta com que se vê e a que gostaria de ter; a diferença entre as
 * duas indica a insatisfação com a imagem corporal.
 * Referência clínica: Stunkard, Sorensen e Schulsinger (1983) e a validação
 * brasileira de Scagliusi et al. (Appetite, 2006). Textos nossos.
 *
 * Os valores precisam ser os mesmos de public/api/scales/catalog/body_image.php.
 */
const silhouette = (n) => ({
  female: `percepcao-imagem-feminino-${n}.png`,
  male: `percepcao-imagem-masculino-${n}.png`,
});

const bodyImage = {
  key: 'body_image',
  name: 'Percepção da imagem corporal',
  description: 'Como o paciente se vê e como gostaria de ser, em 9 silhuetas',
  details: 'Escala de silhuetas de Stunkard: o paciente aponta, entre 9 figuras da mais magra à de maior volume, a que mais se parece com ele hoje e a que gostaria de ter. A diferença entre as duas mostra o tamanho e a direção da insatisfação com o corpo e ajuda a alinhar expectativas do tratamento. Mede a percepção, não substitui peso nem medidas. O card mostra a resposta da última consulta e a aba Saúde guarda a evolução.',
  kind: 'dual',
  icon: AccessibilityNewOutlinedIcon,
  accent: 'purple',
  answers: [
    { key: 'current', label: 'Como se vê' },
    { key: 'desired', label: 'Como gostaria de ser' },
  ],
  difference: {
    unit: ['silhueta', 'silhuetas'],
    lower: 'deseja ser menor',
    higher: 'deseja ser maior',
    equal: 'Satisfeito com a silhueta',
  },
  options: [
    { value: '1', label: '1', image: silhouette(1), help: 'Corpo muito magro, a menor silhueta da escala.' },
    { value: '2', label: '2', image: silhouette(2), help: 'Corpo magro.' },
    { value: '3', label: '3', image: silhouette(3), help: 'Corpo esguio, entre magro e médio.' },
    { value: '4', label: '4', image: silhouette(4), help: 'Corpo de volume médio.' },
    { value: '5', label: '5', image: silhouette(5), help: 'Corpo um pouco acima do volume médio.' },
    { value: '6', label: '6', image: silhouette(6), help: 'Corpo com sobrepeso.' },
    { value: '7', label: '7', image: silhouette(7), help: 'Corpo com sobrepeso acentuado.' },
    { value: '8', label: '8', image: silhouette(8), help: 'Corpo com obesidade.' },
    { value: '9', label: '9', image: silhouette(9), help: 'Corpo com obesidade grave, a maior silhueta da escala.' },
  ],
};

export default bodyImage;
